import React from "react";
// Rutas
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
// SEO
import { HelmetProvider } from "react-helmet-async";
// Páginas
import Home from "./pagesSammy/Home";
import About from "./pagesSammy/About";
import Contact from "./pagesSammy/Contact";
import HomePeople from "./pagesPeopletech/HomePeople";
import AboutPeople from "./pagesPeopletech/AboutPeopletech";
import ContactPeople from "./pagesPeopletech/ContactPeopletech";
import BlogPeople from "./pagesPeopletech/BlogPeople";
import HomeLegacy from "./pagesLegacy/HomeLegacy";
import HomeProyectum from "./pagesProyectum/HomeProyectum";
// Componentes
import Navbar from "./components/Navbar";
import NavbarP from "./componentsPeopletech/NavbarP";
import NavbarL from "./componentsLegacy/NavbarL";
import NavbarPr from "./componentsProyectumcopy/NavbarPr";
import HomeObraSonora from "./componentsObraSonora/Home.jsx";
function App() {
  // Obtiene la ubicación actual de la ruta para renderizar condicionalmente los componentes
  const location = useLocation();

  /**
   * Función que determina qué Navbar renderizar según la ruta actual
   * - /sammy/* -> Navbar de Sammy
   * - / (raíz) -> Navbar de PeopleTech
   * - /legacy/* -> Navbar de Legacy
   * - /proyectum/* -> Navbar de Proyectum
   * - /paisajessonorosdelnoa/* -> Fragmento vacío (sin Navbar)
   * - Otros -> null (sin Navbar)
   */
  const renderNavbar = () => {
    // Verificar rutas específicas primero (orden de más específico a menos específico)
    if (location.pathname.startsWith("/sammy")) {
      return <Navbar />;
    } else if (location.pathname.startsWith("/legacy")) {
      return <NavbarL />;
    } else if (location.pathname.startsWith("/proyectum")) {
      return <NavbarPr />;
    } else if (location.pathname.startsWith("/paisajessonorosdelnoa")) {
      return <React.Fragment/>;
    } else if (location.pathname === "/" || location.pathname.startsWith("/about") || location.pathname.startsWith("/contact") || location.pathname.startsWith("/blog")) {
      // Ruta raíz o rutas de PeopleTech
      return <NavbarP />;
    } else {
      return null; // Opcionalmente, puedes renderizar un Navbar por defecto aquí
    }
  };

  // El SEO ahora se maneja con react-helmet-async en cada página/componente

  return (
    <>
      {/* Renderiza el Navbar solo si no estamos en la ruta de paisajessonorosdelnoa */}
      {!location.pathname.startsWith("/paisajessonorosdelnoa") && renderNavbar()}
      <Routes>
        {/* Rutas para SAMMY */}
        <Route path="/sammy/about" element={<About />} />
        <Route path="/sammy/home" element={<Home />} />
        <Route path="/sammy/contact" element={<Contact />} />
        
        {/* Ruta para Paisajes Sonoros del NOA - Sin Navbar */}
        <Route path="/paisajessonorosdelnoa" element={<HomeObraSonora />} />
        
        {/* Rutas para PeopleTech (ruta raíz) */}
        <Route path="/" element={<HomePeople />} />
        <Route path="/about" element={<AboutPeople />} />
        <Route path="/blog" element={<BlogPeople />} />
        <Route path="/contact" element={<ContactPeople />} />

        {/* Rutas para Legacy */}
        <Route path="/legacy/home" element={<HomeLegacy />} />

        {/* Rutas para Proyectum */}
        <Route path="/proyectum/home" element={<HomeProyectum />} />
      </Routes>
    </>
  );
}

// Envuelve tu App en BrowserRouter y HelmetProvider
export default function WrappedApp() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  );
}
